import { Injectable } from '@angular/core';
import { StoreAmenityResponse } from '@generated/tcea/models/store-amenity-response';
import { UpdateStoreAmenitiesRequest } from '@generated/tcea/models/update-store-amenities-request';
import { AggregatorConfig } from '@interfaces/aggregator/1.0';
import { MenuJob } from '@interfaces/menu-job/1.0';
import { Store, StoreView, StoreViewResponse } from '@interfaces/store/1.0';
import { Observable } from 'rxjs';

@Injectable()
export abstract class AbstractStoreService {
  abstract get(id: string): Observable<StoreView[]>;

  abstract getAllByFilters(
    brandId: string,
    filterParams: string,
    returnResponse: boolean,
  ): Observable<StoreView[] | StoreViewResponse>;

  abstract getPage(brandId: string, filterParams: string): Observable<StoreViewResponse>;

  abstract getAll(brandId: string): Observable<StoreView[] | StoreViewResponse>;

  abstract getOne(storeId: string): Observable<Store>;

  abstract create(newStore: Partial<Store>): Observable<Store>;

  abstract save(store: Partial<Store>, storeId: string): Observable<Store>;

  abstract updateAggregators(storeId: string, aggregators: AggregatorConfig[]): Observable<any>;

  abstract getMenuJobStatus(storeId: string, jobId: string): Observable<MenuJob>;

  abstract getAmenities(brandId: string, storeId: string): Observable<StoreAmenityResponse[]>;

  abstract saveAmenities(
    brandId: string,
    storeId: string,
    amenitiesUpdateRequest: UpdateStoreAmenitiesRequest,
  ): Observable<any[]>;
}
